'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _sign = require('babel-runtime/core-js/math/sign');

var _sign2 = _interopRequireDefault(_sign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _last2 = require('lodash/last');

var _last3 = _interopRequireDefault(_last2);

var _head2 = require('lodash/head');

var _head3 = _interopRequireDefault(_head2);

var _clamp2 = require('lodash/clamp');

var _clamp3 = _interopRequireDefault(_clamp2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactMotion = require('react-motion');

var _touchUtils = require('../touchUtils');

var _Slide = require('../Slide');

var _Slide2 = _interopRequireDefault(_Slide);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SlideContainer = function (_Component) {
    (0, _inherits3.default)(SlideContainer, _Component);

    function SlideContainer() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, SlideContainer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SlideContainer.__proto__ || (0, _getPrototypeOf2.default)(SlideContainer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            isDragging: false,
            dragRatio: 0,
            setX: undefined
        }, _this.onTouchStart = (0, _touchUtils.decorateTouchStart)(function () {
            if (_this.node) {
                _this.size = _this.node.getBoundingClientRect().width;
            }
            _this.setState({ isDragging: true, dragRatio: 0 });
        }), _this.onTouchMove = (0, _touchUtils.decorateTouchMove)(function (delta) {
            _this.setState({
                dragRatio: (0, _clamp3.default)(-delta.x / _this.size, -1, 1)
            });
        }), _this.onTouchEnd = (0, _touchUtils.decorateTouchEnd)(function (delta, velocity) {
            var dragRatio = _this.state.dragRatio;
            // The user is no longer dragging, so reset state

            _this.setState({ isDragging: false });

            var _this$props$carousel = _this.props.carousel,
                currentSlide = _this$props$carousel.currentSlide,
                onSlideChange = _this$props$carousel.onSlideChange;


            var velocityThreshold = 500; // todo make prop or config
            var dragRatioThreshold = 0.25; // A quarter of a slide

            var nextSlide = currentSlide;
            if (Math.abs(velocity.x) > velocityThreshold) {
                nextSlide = currentSlide - (0, _sign2.default)(velocity.x);
            } else if (Math.abs(dragRatio) > dragRatioThreshold) {
                nextSlide = currentSlide + (0, _sign2.default)(dragRatio);
            }

            if (nextSlide !== currentSlide) {
                onSlideChange(nextSlide);
            }
        }), _this.notifyTotalSlides = function () {
            var _this$props$carousel2 = _this.props.carousel,
                totalSlides = _this$props$carousel2.totalSlides,
                setTotalSlides = _this$props$carousel2.setTotalSlides;

            var childCount = _react.Children.count(_this.props.children);
            if (totalSlides !== childCount) {
                setTotalSlides(childCount);
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(SlideContainer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.notifyTotalSlides();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _nextProps$carousel = nextProps.carousel,
                infinite = _nextProps$carousel.infinite,
                nextSlide = _nextProps$carousel.currentSlide,
                totalSlides = _nextProps$carousel.totalSlides;
            var currentSlide = this.props.carousel.currentSlide;


            if (currentSlide === nextSlide) {
                return;
            }

            var didWrap = Math.abs(currentSlide - nextSlide) === totalSlides - 1;

            // In infinite mode, and we've just wrapped around, do an first render
            // on the opposite side of the carousel to avoid a quick "scroll back".
            // This will create the effect of an infinite carousel rather than
            // hitting an end.
            if (infinite && didWrap) {
                var dragRatio = this.state.dragRatio;

                var setX = (nextSlide > currentSlide ? totalSlides + 1 + dragRatio : dragRatio) * 100;
                this.setState({ setX: setX, dragRatio: 0 });
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            /* eslint-disable react/no-did-update-set-state */
            this.notifyTotalSlides();

            var setX = this.state.setX;

            if (setX !== undefined) {
                // After we've rendered in a fixed position, remove the fixed
                // position to let the physics do its work!
                this.setState({ setX: undefined });
            }
            /* eslint-enable react/no-did-update-set-state */
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var children = this.props.children;
            var _state = this.state,
                isDragging = _state.isDragging,
                dragRatio = _state.dragRatio,
                setX = _state.setX;
            var _props$carousel = this.props.carousel,
                theme = _props$carousel.theme,
                currentSlide = _props$carousel.currentSlide,
                infinite = _props$carousel.infinite;


            var numChildren = _react.Children.count(children);
            var clonedChildren = children;

            var springValue = (currentSlide + infinite + dragRatio * isDragging) * 100;
            if (infinite) {
                clonedChildren = _react.Children.toArray(children);
                clonedChildren = [(0, _last3.default)(clonedChildren)].concat((0, _toConsumableArray3.default)(children), [(0, _head3.default)(clonedChildren)]);
            } else {
                // Limit the animation to +/-10% of the container width
                springValue = (0, _clamp3.default)(springValue, -20, 20 + (numChildren - 1) * 100);
            }

            return _react2.default.createElement(
                'div',
                {
                    onTouchStart: this.onTouchStart,
                    onTouchMove: this.onTouchMove,
                    onTouchEnd: this.onTouchEnd,
                    className: theme.slideContainer,
                    ref: function ref(node) {
                        _this2.node = node;
                    }
                },
                _react2.default.createElement(
                    _reactMotion.Motion,
                    {
                        style: {
                            x: setX !== undefined ? setX : (0, _reactMotion.spring)(springValue)
                        }
                    },
                    function (_ref2) {
                        var x = _ref2.x;
                        return _react2.default.createElement(
                            'ul',
                            {
                                className: theme.slideContainerViewport,
                                style: { transform: 'translate3d(' + -x + '%, 0, 0)' }
                            },
                            _react.Children.map(clonedChildren, function (child, index) {
                                var isVirtual = infinite && (index === 0 || index === numChildren + 1);

                                return _react2.default.createElement(
                                    _Slide2.default,
                                    {
                                        isVirtual: isVirtual,
                                        slideIndex: index,
                                        currentSlide: currentSlide + infinite,
                                        totalSlides: numChildren,
                                        theme: theme,
                                        progress: Math.abs(dragRatio * isDragging)
                                    },
                                    child
                                );
                            })
                        );
                    }
                )
            );
        }
    }]);
    return SlideContainer;
}(_react.Component);

SlideContainer.propTypes = {
    children: _propTypes2.default.node.isRequired,
    carousel: _propTypes2.default.shape({
        theme: _propTypes2.default.shape({
            slideContainer: _propTypes2.default.string,
            slideContainerViewport: _propTypes2.default.string,
            changeSlideButton: _propTypes2.default.string,
            changeSlideButtonDisabled: _propTypes2.default.string,
            previousSlideButton: _propTypes2.default.string,
            nextSlideButton: _propTypes2.default.string
        }),
        currentSlide: _propTypes2.default.number.isRequired,
        infinite: _propTypes2.default.bool.isRequired,
        onSlideChange: _propTypes2.default.func.isRequired,
        setTotalSlides: _propTypes2.default.func.isRequired,
        totalSlides: _propTypes2.default.number.isRequired
    }).isRequired
};
exports.default = SlideContainer;
//# sourceMappingURL=SlideContainer.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-carousel/lib/cjs/SlideContainer/SlideContainer.js
 ** module id = 587
 ** module chunks = 1
 **/